var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.42822 8.45496L11.7858 5.50684",
    stroke: "#505050",
    strokeWidth: 0.9,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7858 14.5243L6.42822 11.5762",
    stroke: "#505050",
    strokeWidth: 0.9,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4637 7.09839C16.1478 7.09839 17.5129 5.73322 17.5129 4.04919C17.5129 2.36517 16.1478 1 14.4637 1C12.7797 1 11.4146 2.36517 11.4146 4.04919C11.4146 5.73322 12.7797 7.09839 14.4637 7.09839Z",
    stroke: "#505050",
    strokeWidth: 0.9,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4637 18.9998C16.1478 18.9998 17.5129 17.6346 17.5129 15.9506C17.5129 14.2665 16.1478 12.9014 14.4637 12.9014C12.7797 12.9014 11.4146 14.2665 11.4146 15.9506C11.4146 17.6346 12.7797 18.9998 14.4637 18.9998Z",
    stroke: "#505050",
    strokeWidth: 0.9,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.79919 13.0496C5.48322 13.0496 6.84839 11.6844 6.84839 10.0004C6.84839 8.31634 5.48322 6.95117 3.79919 6.95117C2.11517 6.95117 0.75 8.31634 0.75 10.0004C0.75 11.6844 2.11517 13.0496 3.79919 13.0496Z",
    stroke: "#505050",
    strokeWidth: 0.9,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.3a78b36f00ea07505a7446d381d3924a.svg";
export { ForwardRef as ReactComponent };